module.exports = __webpack_public_path__ + "static/media/guardian_video-hero-img-m.29d2945c.webp";